import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { ROICalculator } from '../components/ROICalculator';
import { WhyUs } from '../components/WhyUs';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-150">
      <Header data-id="element-151" />
      <Hero data-id="element-152" />
      <ProblemSection data-id="element-153" />
      <SolutionSection data-id="element-154" />
      <HowItWorks data-id="element-155" />
      <Services data-id="element-156" />
      <ROICalculator data-id="element-157" />
      <WhyUs data-id="element-158" />
      <CTASection data-id="element-159" />
      <Footer data-id="element-160" />
    </main>;
}